// Servizio dominio PARCO — checkout escursioni (pubblico) + biglietti.
// Riusa l'istanza axios centrale (lib/api.js) tramite ./client.
import { api, unwrap } from './client';

const g = (path, params, config) => unwrap(api.get(path, { params, ...(config || {}) }));
const p = (path, body, config) => unwrap(api.post(path, body, config));

export const parcoService = {
  /** Itinerari/escursioni pubblici (mappa 3D). */
  publicAreas: () => g('/parco/public/areas'),

  /** Elenco pubblico delle guide approvate (vetrina "Le nostre guide"). */
  publicGuides: () => g('/parco/public/guides'),

  /** Profilo pubblico di una guida + suoi itinerari (pagina /guida/:id). */
  publicGuide: (userId) => g(`/parco/public/guides/${userId}`),

  /** Recensioni pubbliche di una guida + riepilogo (media, conteggio, distribuzione). */
  guideReviews: (userId) => g(`/parco/public/guides/${userId}/reviews`),

  /** Crea/aggiorna la propria recensione (solo clienti loggati). */
  submitGuideReview: (userId, body) => p(`/parco/public/guides/${userId}/reviews`, body),

  /** Elimina la propria recensione. */
  deleteGuideReview: (userId) => unwrap(api.delete(`/parco/public/guides/${userId}/reviews`)),

  /** Checkout MOCK di un'escursione. Auth opzionale (ospite o cliente loggato). */
  checkout: (body) => p('/parco/public/checkout', body),

  /** Dettaglio ordine escursione (ownership via email o sessione). */
  getOrder: (id, email) => g(`/parco/public/orders/${id}`, email ? { email } : undefined),
};

const BACKEND = process.env.REACT_APP_BACKEND_URL || '';

/** URL assoluto del PDF biglietti escursione (per download). */
export const excursionPdfUrl = (id, email = '') =>
  `${BACKEND}/api/parco/public/orders/${id}/tickets.pdf${email ? `?email=${encodeURIComponent(email)}` : ''}`;
